import { render } from "./MsisdnInventorySettings.vue?vue&type=template&id=6ab0d719"
import script from "./MsisdnInventorySettings.vue?vue&type=script&lang=js"
export * from "./MsisdnInventorySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__